import React, { useEffect, useState, useCallback, useMemo } from "react";
import { IoMdClose, IoMdAdd } from "react-icons/io";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { IoCalendarClearOutline, IoTimeOutline } from "react-icons/io5";
import { PiTrashThin } from "react-icons/pi";
import { BsPencil } from "react-icons/bs";
import {
  postApiCaller,
  deleteApiCaller,
  putApiCaller,
} from "../../../../Libs/apiCaller";
import { FadeLoader } from "react-spinners";
import {
  decryptMessage,
  decryptText,
  encrypt,
} from "../../../../Components/EncryptDecryptMessage/EncryptDecryptMessage";
import { useSelector } from "react-redux";
import Modal from "../../../../Components/Modals/Modall";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import InfiniteScroll from "../../../../Components/InfiniteScroll/InfiniteScroll";
import { Modal as ResponsiveModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

export default function ScheduleMessage({
  setActiveSection,
  chatConversationId,
  getSecretKey,
  activeChat,
  setShowProfileView,
}) {
  const { userInfo } = useSelector((state) => state.authUser);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [secretKey, setSecretKey] = useState(null);
  const [messages, setMessages] = useState([]);
  const [decryptedMessages, setDecryptedMessages] = useState([]);
  const [dateTimeErr, setDateTimeErr] = useState("");
  const [messageErr, setMessageErr] = useState("");
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [isScheduledCount, setIsScheduledCount] = useState(0);

  const [newMessage, setNewMessage] = useState({
    message: "",
    date: "2025-04-12",
    time: "00:02",
  });

  useEffect(() => {
    setIsLoading(true);
    if (chatConversationId?.AESKeyOfUser) {
      generateSecretKey().then(() => {
        getScheduledMessages(1, false);
      });
    }
  }, [chatConversationId]);

  useEffect(() => {
    if (selectedMessage) {
      const localDate = new Date(selectedMessage.sentTime);
      // Format date as YYYY-MM-DD
      const year = localDate.getFullYear();
      const month = String(localDate.getMonth() + 1).padStart(2, "0");
      const day = String(localDate.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;

      // Format time as HH:mm
      const hours = String(localDate.getHours()).padStart(2, "0");
      const minutes = String(localDate.getMinutes()).padStart(2, "0");
      const time = `${hours}:${minutes}`;

      setNewMessage({
        message: selectedMessage.message,
        date: date,
        time: time,
      });
    } else {
      const [date] = new Date().toISOString().split("T");
      setNewMessage({
        message: "",
        date: date,
        time: "00:00",
      });
    }
  }, [selectedMessage, isModalOpen]);

  const generateSecretKey = async () => {
    const response = await decryptText(
      chatConversationId.AESKeyOfUser,
      userInfo?.encryptedPrivateKey
    );
    setSecretKey(response);
  };

  const getScheduledMessages = async (page = 1, isShowLoading = false) => {
    !isShowLoading && setIsLoading(true);
    const response = await postApiCaller("messages/schedule/get", {
      page,
      conversationId: chatConversationId._id,
      limit: 10,
    });
    if (response?.data?.data) {
      setMessages((prev) => [
        ...(page == 1 ? [] : prev),
        ...response.data.data,
      ]);
      setIsScheduledCount(response.data.futureScheduledCount);
      setTotalPages(response.data.pagination.totalPages || 1);
      setCurrentPage(response.data.pagination.currentPage || 1);
    }
    setIsLoading(false);
  };

  function containsLink(text) {
    const urlPattern = /https?:\/\/[^\s/$.?#].[^\s]*/i;
    return urlPattern.test(text);
  }

  const addScheduledMessage = async () => {
    const { iv, encryptedData } = await encrypt(newMessage.message, secretKey);

    // Create date in user's LOCAL timezone, not UTC
    const [year, month, day] = newMessage.date.split('-');
    const [hours, minutes] = newMessage.time.split(':');
    const localDate = new Date(year, month - 1, day, hours, minutes, 0);

    console.log('[SCHEDULE SEND]', {
      inputDate: newMessage.date,
      inputTime: newMessage.time,
      localDate: localDate.toString(),
      isoDate: localDate.toISOString(),
      nowLocal: new Date().toString(),
      nowISO: new Date().toISOString()
    });

    const data = {
      cipherText: encryptedData,
      iv: iv,
      date: localDate.toISOString(),
      conversationId: chatConversationId._id,
      isLink: containsLink(newMessage.message),
      messageId: uuidv4(),
    };
    const response = await postApiCaller("messages/schedule", data);
    if (response?.status === 200 || response?.status === 201) {
      await getScheduledMessages(1, true);
      setSelectedMessage(null);
      toast.success("Message scheduled successfully");
      setIsModalOpen(false);
      setNewMessage({
        message: "",
        date: "2025-04-12",
        time: "00:02",
      });
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
  };

  const editScheduledMessage = async () => {
    const { iv, encryptedData } = await encrypt(newMessage.message, secretKey);

    // Create date in user's LOCAL timezone, not UTC
    const [year, month, day] = newMessage.date.split('-');
    const [hours, minutes] = newMessage.time.split(':');
    const localDate = new Date(year, month - 1, day, hours, minutes, 0);
    const data = {
      cipherText: encryptedData,
      iv: iv,
      date: localDate.toISOString(),
      conversationId: chatConversationId._id,
      isLink: containsLink(newMessage.message),
    };
    const response = await putApiCaller(
      `messages/schedule/${selectedMessage._id}`,
      data
    );
    if (response?.status === 200 || response?.status === 201) {
      await getScheduledMessages(1, true);
      toast.success("Scheduled message updated successfully");
      setIsModalOpen(false);
      setIsEditing(false);
      setSelectedMessage(null);
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
  };
  const validateForm = () => {
    let isValid = true;
    if (newMessage.message.trim().length <= 0) {
      setMessageErr("Message is required");
      isValid = false;
    }

    if (newMessage.date.length <= 0 || newMessage.time.length <= 0) {
      setDateTimeErr("Date is required");
      isValid = false;
    } else {
      // Validate date format yyyy/mm/dd and year max 4 digits
      const dateRegex = /^(\d{1,4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
      const match = newMessage.date.match(dateRegex);

      if (!match) {
        setDateTimeErr("Date must be in 4-digit year");
        isValid = false;
      } else {
        const year = match[1];
        if (year.length > 4) {
          setDateTimeErr("Year must not exceed 4 digits");
          isValid = false;
        } else {
          // Validate if date+time is in the future
          // Convert input date/time to user's local timezone
          const currentDate = new Date();

          // Get current date in YYYY-MM-DD format for user's timezone
          const today = currentDate.toLocaleDateString("en-CA"); // en-CA gives YYYY-MM-DD format

          // Get current time in HH:mm format for user's timezone
          const now = currentDate.toLocaleTimeString("en-US", {
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          });

          console.log('[SCHEDULE] Validation:', {
            selectedDate: newMessage.date,
            selectedTime: newMessage.time,
            today,
            now,
            comparison: newMessage.date === today && newMessage.time < now
          });

          // Compare dates and times in user's local timezone
          // Use < instead of <= to allow scheduling at the current minute
          if (
            newMessage.date < today ||
            (newMessage.date === today && newMessage.time < now)
          ) {
            setDateTimeErr("Please select date and time in future");
            isValid = false;
          }
        }
      }
    }

    return isValid;
  };

  const handleAddMessage = async () => {
    if (!validateForm()) return;
    setIsModalLoading(true);
    if (selectedMessage) {
      await editScheduledMessage();
    } else {
      await addScheduledMessage();
    }
    setIsModalLoading(false);
  };

  const handleDelete = async () => {
    if (!selectedMessage) return;
    const response = await deleteApiCaller(
      `messages/schedule/${selectedMessage._id}`
    );
    if (response?.status === 200 || response?.status === 201) {
      setMessages((prev) =>
        prev.filter((msg) => msg._id !== selectedMessage._id)
      );
      setIsDeleteModalOpen(false);
      setSelectedMessage(null);
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
  };

  const handleSend = async () => {
    if (!selectedMessage) return;
    const response = await postApiCaller(
      `messages/schedule/send/${selectedMessage._id}`
    );
    if (response?.data) {
      setMessages((prev) =>
        prev.map((msg) =>
          msg._id === selectedMessage._id
            ? { ...msg, sentTime: new Date().toISOString() }
            : msg
        )
      );
      await getScheduledMessages(1, true);
      setIsSendModalOpen(false);
      setSelectedMessage(null);
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
  };

  const getMessages = useCallback(async () => {
    try {
      if (messages.length <= 0 || !secretKey) return [];
      const msgs = messages.map(async (msg) => {
        const decryptedText = await decryptMessage(
          msg?.cipherText,
          msg.iv,
          secretKey
        );
        return { ...msg, message: decryptedText };
      });
      const dt = await Promise.all(msgs);
      setDecryptedMessages(dt);
    } catch (error) {
      console.log(error);
    }
  }, [messages, secretKey]);

  useEffect(() => {
    getMessages();
  }, [getMessages]);

  const formatDate = (DateTime) => {
    const date = new Date(DateTime);
    return date.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const isSent = useCallback((date) => {
    const now = new Date();
    const sentDate = new Date(date);
    return sentDate <= now;
  }, []);

  return (
    <section>
      <div className="sticky w-full min-h-[67px] py-2.5 bg-white flex items-center justify-between border-b text-black p-4 text-center">
        <div className="flex justify-between items-center w-full">
          <div className="w-full items-center bg-white text-black flex gap-4">
            <IoMdClose
              onClick={() => setShowProfileView(false)}
              className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
            />
            <h1 className="text-lg font-semibold text-center">
              Schedule Message
            </h1>
          </div>
          <IoMdAdd
            onClick={() => setIsModalOpen(true)}
            className="cursor-pointer hover:text-white h-8 w-8 p-1 text-white bg-[var(--primary-color)] border rounded-md"
          />
          {isScheduledCount > 0 && (
            <span className="absolute top-0.5 right-1 text-xs px-2 bg-yellow-500 text-white p-1 rounded-full">
              {isScheduledCount}
            </span>
          )}
        </div>
      </div>

      <div
        className={`bg-[#fff] h-[calc(100vh-80px)] min-h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] ${isLoading ? "overflow-hidden" : "overflow-y-auto"
          }`}
      >
        {isLoading ? (
          <div className="h-[100vh] content-center justify-items-center">
            <FadeLoader color="#7104F8" loading={true} size={12} />
          </div>
        ) : messages.length > 0 ? (
          <InfiniteScroll
            dataLength={messages.length}
            next={() => getScheduledMessages(currentPage + 1, true)}
            hasMore={totalPages > currentPage}
            loader={<p>Loading...</p>}
          >
            {decryptedMessages.map((msg, index) => (
              <div
                key={msg._id}
                className={`flex bg-[#f9f6fe] items-center gap-2 px-1.5 pb-1.5 ${index === 0 ? "pt-1.5" : ""
                  }`}
              >
                <div className="bg-white rounded-lg w-full p-4">
                  <div className="flex flex-col gap-1">
                    <div className="flex items-center justify-between gap-2">
                      <p className="font-semibold text-sm">
                        {activeChat?.user?.name}
                      </p>
                      {!isSent(msg.sentTime) && (
                        <div className="flex items-center gap-2">
                          <PiTrashThin
                            onClick={() => {
                              setSelectedMessage(msg);
                              setIsDeleteModalOpen(true);
                            }}
                            className="cursor-pointer hover:text-black h-8 w-8 p-1 text-[#F44336] bg-white border rounded-md"
                          />
                          <BsPencil
                            onClick={() => {
                              setSelectedMessage(msg);
                              setIsModalOpen(true);
                              setIsEditing(true);
                            }}
                            className="cursor-pointer hover:text-black h-8 w-8 p-1.5 text-[var(--primary-color)] bg-white border rounded-md"
                          />
                        </div>
                      )}
                    </div>
                    <p className="text-sm text-gray-700 max-w-xs truncate">
                      {msg.message}
                    </p>
                    <div className="flex justify-between items-center font-normal text-xs text-gray-500 mt-2">
                      <span>
                        {msg.sentTime ? formatDate(msg.sentTime) : ""}
                      </span>
                      {!isSent(msg.sentTime) ? (
                        <button
                          onClick={(ev) => {
                            setIsSendModalOpen(true);
                            setSelectedMessage(msg);
                          }}
                          className="text-[#06B300] font-medium text-xs hover:underline"
                        >
                          Send now
                        </button>
                      ) : (
                        <p className="text-[#06B300] font-medium text-xs">
                          Sent
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </InfiniteScroll>
        ) : (
          <div className="min-h-[calc(100vh-150px)]  content-center justify-items-center">
            <p className="text-[#7104F8] font-semibold text-xl">
              No scheduled messages
            </p>
          </div>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <ResponsiveModal
          open={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setIsEditing(false);
            setDateTimeErr("");
            setMessageErr("");
            setSelectedMessage(null);
          }}
          center
          classNames={{
            modal: "bg-white max-w-xl w-full p-6 rounded-lg",
          }}
          closeIcon={<IoMdClose className="h-6 w-6" />}
          showCloseIcon={false}
        >
          <div className="flex justify-between items-center pb-6">
            <h3 className="font-semibold text-lg">
              {isEditing ? "Edit Schedule Message" : "New Schedule Message"}
            </h3>
            <IoMdClose
              onClick={() => {
                setIsModalOpen(false);
                setIsEditing(false);
                setDateTimeErr("");
                setMessageErr("");
                setIsModalLoading(false);
                setSelectedMessage(null);
              }}
              className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
            />
          </div>

          <div className="space-y-4">
            <div>
              <label className="font-normal text-[#525252] block text-sm">
                Recipient
              </label>
              <p className="mt-1 font-medium text-gray-700">
                {activeChat?.user?.name}
              </p>
            </div>
            <div>
              <label className="font-normal text-[#525252] block text-sm mb-1.5">
                Message
              </label>
              <textarea
                type="text"
                value={newMessage.message}
                onChange={(e) => {
                  setNewMessage({ ...newMessage, message: e.target.value });
                  if (e.target.value.length <= 0) {
                    setMessageErr("Message is required");
                  } else {
                    setMessageErr("");
                  }
                }}
                className="input bg-inherit px-2 input-bordered border border-[#EBEBEB] rounded-lg py-1 w-full"
                placeholder="Enter Message"
              />

              {messageErr && (
                <p className="text-red-500 text-sm">{messageErr}</p>
              )}
            </div>
            <div>
              <div className="grid grid-cols-2 gap-4">
                <label htmlFor="date-input">
                  <span className="font-normal text-[#525252] block text-sm mb-1.5">
                    Send out at
                  </span>
                  <div className="relative">
                    <input
                      id="date-input"
                      name="date-input"
                      type="date"
                      value={newMessage.date}
                      min={new Date().toISOString().split("T")[0]} // Set minimum date to today
                      onChange={(e) => {
                        setNewMessage({
                          ...newMessage,
                          date: e.target.value,
                        });
                        if (
                          e.target.value.length <= 0 ||
                          newMessage.time.length <= 0
                        ) {
                          setDateTimeErr("Date and time is required");
                        } else {
                          setDateTimeErr("");
                        }
                      }}
                      className="input input-bordered border px-2 border-[#EBEBEB] bg-white rounded-lg w-full py-5 pr-10 text-black"
                    />
                    {/* <IoCalendarClearOutline className="absolute right-3 top-2.5 text-gray-500 pointer-events-none text-lg" /> */}
                  </div>
                </label>

                <label htmlFor="time-input">
                  <span className="font-normal text-[#525252] block text-sm mb-1.5">
                    Time
                  </span>
                  <div className="relative">
                    <input
                      id="time-input"
                      name="time-input"
                      type="time"
                      value={newMessage.time}
                      onChange={(e) => {
                        setNewMessage({
                          ...newMessage,
                          time: e.target.value,
                        });

                        // Create date in user's local timezone (no hardcoded offset)
                        const combinedDate = new Date(`${newMessage.date}T${e.target.value}:00`);
                        const currentDate = new Date();
                        if (
                          e.target.value.length <= 0 ||
                          newMessage.date.length <= 0
                        ) {
                          setDateTimeErr("Date and time is required");
                        } else if (combinedDate <= currentDate) {
                          setDateTimeErr(
                            "Please select date and time in future"
                          );
                        } else {
                          setDateTimeErr("");
                        }
                      }}
                      className="input input-bordered border px-2 border-[#EBEBEB] bg-white rounded-lg w-full py-5 pr-10 text-black"
                    />
                    {/* <IoTimeOutline className="absolute right-3 top-3 text-gray-500 text-lg" /> */}
                  </div>
                </label>
              </div>
              {dateTimeErr && (
                <p className="text-red-500 text-sm mt-1 errorMsg">
                  {dateTimeErr}
                </p>
              )}
            </div>
          </div>

          <div className="modal-action mt-6">
            <button
              onClick={handleAddMessage}
              disabled={isModalLoading}
              className="btn border-none px-10 py-5 text-white font-medium shadow-none bg-[var(--primary-color)] rounded-full"
            >
              {isModalLoading ? "Saving..." : "Save"}
            </button>
          </div>
          {/* </div> */}
        </ResponsiveModal>
      )}
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Delete Message"
        description="Are you sure you want to delete this message?"
        onConfirm={handleDelete}
      />
      <Modal
        isOpen={isSendModalOpen}
        onClose={() => setIsSendModalOpen(false)}
        title="Send Message"
        description="Are you sure you want to send this message?"
        onConfirm={handleSend}
      />
    </section>
  );
}
